<template>
  <div>
    <v-container>
      <v-dialog v-model="dialogComponent" width="500">
        <template v-slot:activator="{ on }">
          <v-row align-center mt-1 v-on="on">
            <v-col
              cols="12"
              class="add-component text-center pt-3 pb-3"
              fill-height
            >
              <p class="ma-0 font-weight-regular">Agregar componente</p>
              <p class="add-component-text ma-0">
                (En caso que el equipo cuente con algún componente, se puede
                agregar al listado)
              </p>
            </v-col>
          </v-row>
        </template>
        <v-card>
          <v-card-title class="headline grey lighten-2 d-flex" primary-title>
            <p class="ma-0">Agregar componente</p>
            <v-icon class="ml-auto" @click="dialogComponent = false"
              >clear</v-icon
            >
          </v-card-title>
          <v-container>
            <v-row>
              <v-col cols="12">
                <p class="body-2 ma-0 font-weight-light">
                  Escriba en el campo el nombre del componente faltante.
                </p>
                <v-form ref="formComponent">
                  <v-text-field
                    label="Nombre del componente"
                    v-model="textNewComponent"
                    required
                    :rules="nameComponentRules"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="accent"
                    @click="saveComponent()"
                    block
                    class="black--text body-1"
                    >Guardar</v-btn
                  >
                </v-form>
              </v-col>
            </v-row>
          </v-container>
          <v-container></v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialogComponent: false,
      textNewComponent: "",
      nameComponentRules: [v => !!v || "Nombre del componente requerido"]
    };
  },

  methods: {
    saveComponent() {
      if (this.accessToEdit) return;
      if (this.$refs.formComponent.validate()) {
        let format = "";
        if (this.textNewComponent.split(/\s+|\./).length == 1) {
          format = this.textNewComponent;
        } else {
          format = this.camelize(this.textNewComponent);
        }
        let data = {
          title: this.textNewComponent,
          checklistName: format,
          checked: false,
          incidence: false,
          notApply: false
        };
        this.dialogComponent = false;
        // add item to data structure
        this.checklistArray.push(data);

        this.textNewComponent = ""; //reset
      }
    },
    camelize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
          return index == 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
    }
  },
  computed: {
    ...mapState("checklist", ["checklistArray"])
  },
  props: ["accessToEdit"]
};
</script>

<style scoped>
.add-component {
  background-color: #efefef;
  size: 10px;
}
.add-component-save {
  color: black !important;
}
.add-component-text {
  color: #a0a0a0;
  font-size: 10px !important;
}
</style>
